class Accordion {
  constructor($wrapper, options) {
    if (!$wrapper) {
      throw new Error('Accordion wrapper is required');
    }

    this.$wrapper = $wrapper;
    this.$head = $wrapper.querySelector('.accordion-head');
    this.$body = $wrapper.querySelector('.accordion-body');

    if (!this.$head || !this.$body) {
      throw new Error('Accordion head or body missing');
    }

    this.toggleCallback = (
      (options && options.toggleCallback) ||
      (() => {})
    ).bind(this);
    this.toggleSpeed = (options && options.toggleSpeed) || 600;
    this.transitionOngoing = false;

    this.isClosed = this.$wrapper.classList.contains('accordion-isclosed');

    if (this.isClosed) {
      this.instantClose();
    } else {
      this.instantOpen();
    }

    this.toggle = this.toggle.bind(this);
    this.$head.addEventListener('click', () => {
      this.toggle();
    });

    this.$head.tabIndex = 0;
    this.$head.role = 'button';
  }

  get bodyHeight() {
    const { $body } = this;
    let height;
    if (this.isClosed) {
      $body.style.removeProperty('display');
      height = $body.clientHeight;
      $body.style.setProperty('display', 'none');
    } else {
      height = $body.clientHeight;
    }
    return height;
  }

  toggle() {
    this.toggleCallback();
    if (this.isClosed) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    if (!this.isClosed || this.transitionOngoing) return;
    this.transitionOngoing = true;
    const { $wrapper, $head, $body, bodyHeight } = this;
    $body.style.setProperty('max-height', '0');
    setTimeout(() => {
      $body.style.setProperty('max-height', `${bodyHeight}px`);
    }, 0);
    $body.style.removeProperty('display');
    $wrapper.classList.remove('accordion-isclosed');
    this.isClosed = false;
    $head.ariaExpanded = 'true';

    $wrapper.addEventListener(
      'transitionend',
      () => {
        $body.style.removeProperty('max-height');
        this.transitionOngoing = false;
      },
      { once: true },
    );
  }

  instantOpen() {
    if (this.transitionOngoing) return;
    const { $wrapper, $head, $body } = this;
    $body.style.removeProperty('display');
    $wrapper.classList.remove('accordion-isclosed');
    this.isClosed = false;
    $head.ariaExpanded = 'true';
  }

  close() {
    if (this.isClosed || this.transitionOngoing) return;
    this.transitionOngoing = true;
    const { $wrapper, $head, $body, bodyHeight } = this;
    $body.style.setProperty('max-height', `${bodyHeight}px`);
    setTimeout(() => {
      $body.style.setProperty('max-height', '0');
    }, 0);
    $wrapper.classList.add('accordion-isclosed');
    this.isClosed = true;
    $head.ariaExpanded = 'false';

    $wrapper.addEventListener(
      'transitionend',
      () => {
        $body.style.removeProperty('max-height');
        $body.style.setProperty('display', 'none');
        this.transitionOngoing = false;
      },
      { once: true },
    );
  }

  instantClose() {
    if (this.transitionOngoing) return;
    const { $wrapper, $head, $body } = this;
    $wrapper.classList.add('accordion-isclosed');
    $body.style.setProperty('display', 'none');
    this.isClosed = true;
    $head.ariaExpanded = 'false';
  }

  destroy() {
    this.isClosed && this.instantOpen();
    this.$head.removeEventListener('click', this.toggle);
    this.$head.tabIndex = -1;
    this.$head.role = '';
  }
}

export { Accordion };
